import { CaptCha } from './capt-cha';

const CustomCaptcha = {
    Root: CaptCha,
};

export type * from './capt-cha';
export default CustomCaptcha;
